var _path, _path2, _g, _path3, _path4, _g2, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.194 147.919C161.09 142.62 177.563 140.743 189.896 140.227C199.868 139.809 195.11 108.463 189.697 108.367C183.098 108.249 177.857 108.847 173.972 109.353C163.366 110.735 145.94 111.392 135.135 115.467C113.041 123.8 83.5519 144.061 46.6689 176.252L46.6674 176.25C44.9834 177.719 44.8085 180.274 46.2769 181.958C46.295 181.979 46.3134 182 46.3319 182.02L65.1969 202.763C66.7019 204.414 69.2607 204.533 70.9121 203.028C70.9236 203.017 70.9351 203.007 70.9465 202.996C103.678 172.478 128.762 154.12 146.194 147.919Z",
    fill: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_2861",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 108,
    width: 151,
    height: 97
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.194 147.919C161.09 142.62 177.563 140.743 189.896 140.227C199.868 139.809 195.11 108.463 189.697 108.367C183.098 108.249 177.857 108.847 173.972 109.353C163.366 110.735 145.94 111.392 135.135 115.467C113.041 123.8 83.5519 144.061 46.6689 176.252L46.6674 176.25C44.9834 177.719 44.8085 180.274 46.2769 181.958C46.295 181.979 46.3134 182 46.3319 182.02L65.1969 202.763C66.7019 204.414 69.2607 204.533 70.9121 203.028C70.9236 203.017 70.9351 203.007 70.9465 202.996C103.678 172.478 128.762 154.12 146.194 147.919Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_2861)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_125_2861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.125 113.335L95.315 113.334H154.172H208.788V150.007H154.169H95.3113L44.125 150.008V113.335Z",
    fill: "black",
    fillOpacity: 0.2
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3957 107.103L95.2015 107.102L152.969 107.102C153.084 107.102 153.199 107.107 153.313 107.117L181.991 109.565V142.082H153.138H95.1979L31.3957 142.082C29.1613 142.082 27.35 140.271 27.35 138.037C27.35 138.037 27.35 138.036 27.35 138.036L27.3501 111.149C27.3501 108.915 29.1614 107.103 31.3957 107.103V107.103Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_125_2861",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 107,
    width: 155,
    height: 36
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3957 107.103L95.2015 107.102L152.969 107.102C153.084 107.102 153.199 107.107 153.313 107.117L181.991 109.565V142.082H153.138H95.1979L31.3957 142.082C29.1613 142.082 27.35 140.271 27.35 138.037C27.35 138.037 27.35 138.036 27.35 138.036L27.3501 111.149C27.3501 108.915 29.1614 107.103 31.3957 107.103V107.103Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_125_2861)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_125_2861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.633 107.861C170.153 117.001 201.75 115.466 205.138 114.884C205.138 114.884 205.138 121.522 205.138 134.798C205.138 137.678 205.138 142.7 205.138 149.864C189.325 150.957 177.939 151.065 170.978 150.186C160.538 148.868 143.383 146.266 132.747 142.379C127.143 140.331 120.894 137.276 114.373 133.608C81.8716 115.324 42.6014 81.8033 42.6014 81.8033L66.6114 56.2226C66.6114 56.2226 117.114 98.72 143.633 107.861ZM256.323 44.4672L219.718 70.8571C216.999 72.8171 213.206 72.202 211.246 69.4834C210.501 68.45 210.1 67.2084 210.1 65.9345V13.1548C210.1 9.80329 212.817 7.08636 216.169 7.08636C217.443 7.08636 218.684 7.48726 219.718 8.23224L256.323 34.6221C259.041 36.5821 259.656 40.3749 257.696 43.0935C257.315 43.6222 256.851 44.0861 256.323 44.4672Z",
    fill: "black",
    fillOpacity: 0.2
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.266 102.847C158.173 106.082 167.279 107.862 175.579 108.777C192.055 110.593 185.63 143.148 175.128 142.379C161.185 141.357 147.82 140.472 135.034 135.548C113.217 127.147 84.0943 106.713 47.6667 74.2461L47.6617 74.2517C45.9967 72.7672 45.8475 70.215 47.3282 68.5466L66.0297 47.5522C67.5172 45.885 70.0746 45.7395 71.7418 47.227L71.7443 47.2293C106.198 78.0515 132.039 96.5898 149.266 102.847ZM220.885 128.5L179.054 156.969C177.207 158.226 174.691 157.748 173.434 155.901C172.977 155.229 172.733 154.436 172.733 153.624V96.6863C172.733 94.452 174.544 92.6407 176.778 92.6407C177.59 92.6407 178.383 92.885 179.054 93.3418L220.885 121.811C222.732 123.068 223.21 125.584 221.953 127.432C221.667 127.852 221.305 128.214 220.885 128.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_125_2861",
    x: 40.0794,
    y: 109.288,
    width: 172.754,
    height: 44.7648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02281,
    result: "effect1_foregroundBlur_125_2861"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_125_2861",
    x: 34.5102,
    y: -1.00488,
    width: 232.424,
    height: 159.87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.04562,
    result: "effect1_foregroundBlur_125_2861"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImg);
export default __webpack_public_path__ + "static/media/logo-img.4d8faf5a5057b375d8b0c4bc7c84ed8b.svg";
export { ForwardRef as ReactComponent };